export default __webpack_public_path__ + "static/media/stephnora.3b3c7dfe.png";